// const baseURL = "";
const baseURL = "https://mantap.solutionlab.id/api";
export default baseURL;
